import { LazyMotion, domAnimation } from 'framer-motion';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/feedback/toaster';
import { queryClient } from '@/lib/query-client';
import { AuthModal } from '@/features/auth-stub/components/auth-modal';
import type { ReactNode } from 'react';

export const Providers = ({ children }: { children: ReactNode }) => (
  <LazyMotion features={domAnimation}>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={150}>
        {children}
        <AuthModal />
        <Toaster />
      </TooltipProvider>
      {import.meta.env.DEV && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
      )}
    </QueryClientProvider>
  </LazyMotion>
);
